import { FC } from "react";
import { EvaluatedFeedbackNumberQuestionResource } from "../types/feedback";

interface Props {
	question: EvaluatedFeedbackNumberQuestionResource;
}
export const CompactFeedbackNumberQuestionEvaluation: FC<Props> = ({ question }) => {
	return (
		<span>
			{question.evaluation.sum} (⌀ {question.evaluation.average.toFixed(2)})
		</span>
	);
};
